import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { SectionLabel } from '../ui/SectionLabel';
export function UrgencyBanner() {
  return <section aria-labelledby="urgencia-title" className="w-full bg-pitch" data-id="element-221" data-mp="238z9f25ibtjb">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center md:py-20" data-id="element-222" data-mp="2hx3rq50ne31k">
        <SectionLabel tone="gold" data-id="element-223" data-mp="2d4k4shg2lvk3">Oferta de hoy · Solo por hoy</SectionLabel>
        <h2 id="urgencia-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-224" data-mp="2qw7b7a3q8kgl">
          La oferta de hoy termina hoy
        </h2>
        <p className="mt-4 max-w-xl text-base text-body" data-id="element-225" data-mp="30v6d89tzlhum">
          Después, el precio aumentará y el paquete dejará de estar disponible a este valor.
        </p>
        <div className="mt-8" data-id="element-226" data-mp="2vtz6me3kyopj">
          <CtaButton size="xl" data-id="element-227" data-mp="16gdj6f8r4z4s">Aprovechar la oferta de hoy</CtaButton>
        </div>
      </div>
    </section>;
}